import React from "react";
import { type FreefieldInputProps } from "../models";
import UrlInput from "components/urlinput";

const FreefieldUrl = (props: FreefieldInputProps & { validatorKey: string }) => {
  const [text, setText] = React.useState(props.initialValue ?? "");

  const onChange = (value: string) => {
    setText(value);
    props.onChange(value);
  };

  return <UrlInput
    validatorKey={props.validatorKey}
    value={text}
    onValueChange={onChange}
  />;
};

export default FreefieldUrl;